import { render } from "./ReturnToTopButton.vue?vue&type=template&id=5f56207a&scoped=true"
import script from "./ReturnToTopButton.vue?vue&type=script&lang=js"
export * from "./ReturnToTopButton.vue?vue&type=script&lang=js"

import "./ReturnToTopButton.vue?vue&type=style&index=0&id=5f56207a&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f56207a"]])

export default __exports__